import './styles.scss'

import Sticky from 'react-stickynode'

import B2BecLink from '@/components/B2BLink'
import { useAppSelector } from '@/store/hook'
import { selectLogo } from '@/store/selectors/configSelector'

import Content from '../Content'

function Header() {
  const logo = useAppSelector(selectLogo)
  return (
    <Sticky innerZ={1} top={0}>
      <Content className="public-page__header__wrapper">
        <B2BecLink to="">
          <img
            alt="Kaercher Logo"
            className="public-page__header__logo"
            src={logo}
          />
        </B2BecLink>
      </Content>
    </Sticky>
  )
}

export default Header
